import { initializeApp } from 'firebase/app';
import { initializeAuth, indexedDBLocalPersistence, browserLocalPersistence } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { mockFirebaseConfig } from './mockConfig';
import { isDevelopmentMode } from '../../utils/env-helper';

// Firebase configuration from environment variables
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || (isDevelopmentMode() ? mockFirebaseConfig.apiKey : ''),
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || (isDevelopmentMode() ? mockFirebaseConfig.authDomain : ''),
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || (isDevelopmentMode() ? mockFirebaseConfig.databaseURL : ''),
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || (isDevelopmentMode() ? mockFirebaseConfig.projectId : ''),
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || (isDevelopmentMode() ? mockFirebaseConfig.storageBucket : ''),
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || (isDevelopmentMode() ? mockFirebaseConfig.messagingSenderId : ''),
  appId: process.env.REACT_APP_FIREBASE_APP_ID || (isDevelopmentMode() ? mockFirebaseConfig.appId : ''),
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || (isDevelopmentMode() ? mockFirebaseConfig.measurementId : '')
};

// Validate configuration
if (!firebaseConfig.apiKey && !isDevelopmentMode()) {
  throw new Error('Firebase configuration is missing. Please set environment variables.');
}

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize auth with proper iOS persistence hierarchy for Capacitor
export const auth = initializeAuth(app, {
  persistence: [indexedDBLocalPersistence, browserLocalPersistence]
});

export const database = getDatabase(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Export for compatibility
export { app };